import type { GlobalConfigurationDto } from "../../types/GlobalConfigurationDto";
import type { GlobalConfigurationEntity } from "../../types/GlobalConfigurationEntity";

export const GlobalConfigurationDtoToEntity = ({ ...rest }: Readonly<GlobalConfigurationDto>): GlobalConfigurationEntity => {
    return { ...rest };
};
